module.exports = __webpack_public_path__ + "img/visa.44350dff.png";